var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FieldItem",
    { attrs: { id: _vm.id, label: _vm.$t(_vm.fieldConfig.label) } },
    [
      _c(
        "ElSelect",
        {
          staticClass: "search-preference__select",
          attrs: { size: "small", placeholder: _vm.$t(_vm.fieldConfig.label) },
          on: { change: _vm.syncChange },
          model: {
            value: _vm.fieldValue,
            callback: function ($$v) {
              _vm.fieldValue = $$v
            },
            expression: "fieldValue",
          },
        },
        _vm._l(_vm.finalLimitOptions, function (option) {
          return _c(
            "ElOption",
            {
              key: option.value,
              attrs: { value: option.value, disabled: option.disabled },
            },
            [
              option.tooltip
                ? _c(
                    "ElTooltip",
                    {
                      attrs: {
                        placement: "right-start",
                        effect: "light",
                        "visible-arrow": false,
                        content: option.tooltip,
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(option.label))])]
                  )
                : _c("span", [_vm._v(" " + _vm._s(option.label) + " ")]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }